import React, { useRef } from 'react'
import { orderByState } from '../../recoil/state/search'
import { useRecoilValue, useRecoilCallback } from 'recoil'
import {
  ContextMenu,
  CONTEXT_MENU_SIZE_SM,
  makeButtonWithMenu,
  Text,
  TEXT_VARIANT_SMALL,
  TEXT_VARIANT_SMALL_LIGHT
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { searchMessagesCallback } from '../../recoil/callbacks/callbacks'

export const OrderBy = () => {
  const intl = useIntl()

  const orderBy = useRecoilValue(orderByState)

  const fetchResults = useRecoilCallback(searchMessagesCallback, [])

  const { current: handleClickOption } = useRef(orderBy => {
    fetchResults({ orderBy, pageNumber: 1 })
  })

  const { current: options } = useRef([
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.LastUpdateHeaderColumn'
      }),
      value: 'LastUpdated DESC',
      onClick: handleClickOption
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.LastSentHeaderColumn'
      }),
      value: 'LastSent DESC',
      onClick: handleClickOption
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.subjectAsc'
      }),
      value: 'Subject ASC',
      onClick: handleClickOption
    },
    {
      label: intl.formatMessage({
        id: 'Load.EmailMessageList.subjectDesc'
      }),
      value: 'Subject DESC',
      onClick: handleClickOption
    }
  ])

  const selectedOption = orderBy
    ? options.find(({ value }) => value === orderBy || '')
    : options.find(({ value }) => value === 'LastUpdated DESC')

  const Component = makeButtonWithMenu(
    () => (
      <>
        <Text
          variant={TEXT_VARIANT_SMALL}
          htmlElement='span'
          className='c-message-list-controls__orderby__label'
        >
          {intl.formatMessage({ id: 'Load.TableHeader.Order' })}
        </Text>
        <Text
          variant={TEXT_VARIANT_SMALL_LIGHT}
          htmlElement='span'
          className='c-message-list-controls__orderby__value'
        >
          {selectedOption.label}
        </Text>
      </>
    ),
    () => (
      <ContextMenu
        className='c-message-list-controls__orderby__menu'
        selected={orderBy}
        items={options}
        size={CONTEXT_MENU_SIZE_SM}
      />
    )
  )

  return <Component />
}
